var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _rect2, _path18, _path19, _path20, _path21, _path22, _path23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCastling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    id: "castling",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3c3b41",
    d: "M307.2 474.44h181.6a15.7 15.7 0 0 1 15.7 15.7v14.36h-213v-14.36a15.7 15.7 0 0 1 15.7-15.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2a2c",
    d: "M488.8 474.44h-15a15.7 15.7 0 0 1 15.7 15.7v14.36h15v-14.36a15.7 15.7 0 0 0-15.7-15.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b8992",
    d: "M464.3 398.58H331.7a15 15 0 0 0-13.95 9.49L299.61 454a15 15 0 0 0 13.95 20.51h168.88A15 15 0 0 0 496.39 454l-18.14-45.92a15 15 0 0 0-13.95-9.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#78777f",
    d: "m496.39 454-18.14-45.93a15 15 0 0 0-13.95-9.48h-15a15 15 0 0 1 13.95 9.48L481.39 454a15 15 0 0 1-13.95 20.51h15A15 15 0 0 0 496.39 454Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8c6cb",
    d: "M453.99 398.63H342.01l15-183.05h81.98l15 183.05z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#aeadb3",
    d: "M438.99 215.58h-15l15 183.05h15l-15-183.05z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 30,
    x: 333,
    y: 185.56,
    fill: "#3c3b41",
    rx: 10.9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2a2c",
    d: "M452.1 185.56h-15a10.9 10.9 0 0 1 10.9 10.9v8.21a10.89 10.89 0 0 1-10.9 10.89h15a10.89 10.89 0 0 0 10.9-10.89v-8.21a10.9 10.9 0 0 0-10.9-10.9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b8992",
    d: "M450.75 85.8v47.66h-31.43V85.8h-42.13v47.66h-31.44V85.8h-30v90a10 10 0 0 0 10 10h145a10 10 0 0 0 10-10v-90Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#78777f",
    d: "M465.75 85.8v90a10 10 0 0 1-10 10h15a10 10 0 0 0 10-10v-90ZM404.32 85.8h15v47.66h-15zM330.75 85.8h15v47.66h-15z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8c6cb",
    d: "M155.45 40.43h-27.51V12.5a5 5 0 0 0-5-5h-17.88a5 5 0 0 0-5 5v27.93H72.55a5 5 0 0 0-5 5v17.25a5 5 0 0 0 5 5h27.51v36.16h27.88V67.68h27.51a5 5 0 0 0 5-5V45.43a5 5 0 0 0-5-5Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#aeadb3",
    d: "M112.94 67.68h15v36.16h-15zM112.94 12.5v27.93h15V12.5a5 5 0 0 0-5-5h-15a5 5 0 0 1 5 5zm42.51 27.93h-15a5 5 0 0 1 5 5v17.25a5 5 0 0 1-5 5h15a5 5 0 0 0 5-5V45.43a5 5 0 0 0-5-5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b8992",
    d: "M158.46 103.84H69.07a15 15 0 0 0-14.45 19L72 185.56h82l18.83-62.39a15 15 0 0 0-14.37-19.33Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#78777f",
    d: "M158.46 103.84h-15a15 15 0 0 1 14.36 19.33L139 185.56h15l18.83-62.39a15 15 0 0 0-14.37-19.33Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c3b41",
    d: "M23.2 474.44h181.6a15.7 15.7 0 0 1 15.7 15.7v14.36H7.5v-14.36a15.7 15.7 0 0 1 15.7-15.7Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2a2c",
    d: "M204.8 474.44h-15a15.7 15.7 0 0 1 15.7 15.7v14.36h15v-14.36a15.7 15.7 0 0 0-15.7-15.7Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b8992",
    d: "M180.3 398.58H47.7a15 15 0 0 0-14 9.49L15.61 454a15 15 0 0 0 14 20.51h168.83A15 15 0 0 0 212.39 454l-18.14-45.92a15 15 0 0 0-13.95-9.5Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#78777f",
    d: "m212.39 454-18.14-45.93a15 15 0 0 0-13.95-9.48h-15a15 15 0 0 1 13.95 9.48L197.39 454a15 15 0 0 1-13.95 20.51h15A15 15 0 0 0 212.39 454Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 30,
    x: 49,
    y: 185.56,
    fill: "#3c3b41",
    rx: 10.9
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2a2c",
    d: "M168.1 185.56h-15a10.9 10.9 0 0 1 10.9 10.9v8.21a10.89 10.89 0 0 1-10.9 10.89h15a10.89 10.89 0 0 0 10.9-10.89v-8.21a10.9 10.9 0 0 0-10.9-10.9Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8c6cb",
    d: "M169.99 398.57H58.01l15-183.05h81.98l15 183.05z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#aeadb3",
    d: "M154.99 215.52h-15l15 183.05h15l-15-183.05z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c3b41",
    d: "M165.17 148.52a7.16 7.16 0 0 0-1.61-.18H64.44a7.34 7.34 0 0 0-2.62.48l4 14.52h94.88Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2a2c",
    d: "M163.56 148.34h-15a7.16 7.16 0 0 1 1.61.18l-4.47 14.82h15l4.47-14.82a7.16 7.16 0 0 0-1.61-.18Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c3b41",
    d: "m310.35 338.36-28.07-28.07a7.5 7.5 0 0 0-10.6 10.61l15.92 15.92H207a7.5 7.5 0 0 0 0 15h79.33l-14.6 14.6A7.5 7.5 0 1 0 282.28 377l25.91-25.91a7.49 7.49 0 0 0 4.36-6.8v-.66a7.49 7.49 0 0 0-2.2-5.27zm-109.41-85.13-.22.3c-.08.11-.14.23-.21.34s-.12.19-.17.29-.11.23-.17.35-.1.21-.14.31-.09.24-.13.35-.09.23-.12.35l-.09.36a3.58 3.58 0 0 0-.09.35c0 .14 0 .28-.07.42s0 .2 0 .3a7.42 7.42 0 0 0 0 1.49v.3c0 .1 0 .28.07.42s.06.24.09.36.05.24.09.36.08.22.12.34.08.23.13.35.09.21.14.31.11.24.17.35a2.75 2.75 0 0 0 .17.29 3.87 3.87 0 0 0 .21.34 3.3 3.3 0 0 0 .22.3 3.15 3.15 0 0 0 .22.29c.13.16.27.31.41.46l.08.09 28.07 28.07a7.5 7.5 0 0 0 10.6-10.61l-15.26-15.26h80a7.5 7.5 0 0 0 0-15h-80l15.26-15.27a7.5 7.5 0 0 0-10.6-10.6l-28.07 28.06-.08.09c-.14.15-.28.3-.41.46a3.15 3.15 0 0 0-.22.29z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCastling);
export default __webpack_public_path__ + "static/media/castling.579f4292341d4f8a9dc413e6a1ba9fec.svg";
export { ForwardRef as ReactComponent };